<!--
 * @Description: 
 * @Author: jiawei
 * @Date: 2021-11-18 09:13:28
 * @LastEditTime: 2022-02-11 09:22:24
 * @LastEditors: jiawei
 * @Reference: 
-->
<template>
  <div>
    <Form ref="StepOneForm" :model="collectionManagement" :label-width="90">
      <Row>
        <Col span="5">
          <FormItem label="付款编号" prop="paymentNo">
            <Input
              v-model="collectionManagement.paymentNo"
              placeholder="请输入付款编号"
            />
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="发票编号" prop="billNo">
            <Input
              v-model="collectionManagement.billNo"
              placeholder="请输入发票编号"
            />
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="银行账户名称" prop="bankAccountName">
            <Input
              v-model="collectionManagement.bankAccountName"
              placeholder="请输入银行账户名称"
            />
          </FormItem>
        </Col>

        <Col span="5">
          <FormItem label="付款日期" prop="validityTime">
            <DatePicker
              type="daterange"
              v-model="collectionManagement.date"
              @on-change="
                (date) => {
                  collectionManagement.date = date;
                  collectionManagement.paidDateStart = date[0];
                  collectionManagement.paidDateEnd = date[1];
                }
              "
              transfer
              format="yyyy-MM-dd"
              placeholder="请选择日期范围"
              style="width: 100%; margin-right: 20px"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col offset="1" span="3">
          <div>
            <Button
              @click="getPaymentQuery(1)"
              class="ivu-btn ivu-btn-primary"
              style="margin-right: 5px"
              >查询</Button
            >
            <Button @click="reset()">重置</Button>
          </div>
        </Col>
      </Row>
    </Form>
    <Row style="margin: 20px 0">
      <Col span="21">
        <Button
          @click="addManagement('add')"
          v-if="button.paymentManagement_add"
          class="ivu-btn ivu-btn-primary"
          style="margin-right: 20px"
          >新增付款计划</Button
        >
        <Upload
          :action="$api.paymentImport"
          ref="upload"
          :show-upload-list="false"
          :on-success="handleSuccessRecord"
          :on-progress="handleProgress"
          :on-format-error="handleFormatError"
          :headers="headers"
          :format="['xls', 'xlsx']"
          style="display: inline-block"
        >
          <div>
            <Button
              type="success"
              style="margin-right: 20px"
              v-if="button.paymentManagement_addImport"
              >新增付款记录导入</Button
            >
          </div>
        </Upload>

        <a
          @click="paymentTemplate()"
          v-if="button.paymentManagement_exportModel"
          style="margin-right: 20px; text-decoration: underline"
          >下载导入模板</a
        >

        <Button
          @click="paymentExport()"
          v-if="button.paymentManagement_exportAll"
          type="warning"
          style="margin-right: 20px"
          >付款记录导出</Button
        >

        <Button
          @click="paymentDel"
          type="error"
          style="margin-right: 20px"
          v-if="button.paymentManagement_del"
          >批量删除</Button
        >
      </Col>
    </Row>
    <primaryTable
      :columns="collectionManagementColumns"
      :data="collectionManagementTableList"
      ref="primaryTable"
      :total="total"
      @on-change="changePage"
      @on-select="tableSelect"
      :loading="tableloading"
      :current.sync="collectionManagement.pageNum"
      @on-page-size-change="
        (pageSize) => {
          collectionManagement.pageSize = pageSize;
          getPaymentQuery(1);
        }
      "
    ></primaryTable>

    <Modal
      v-model="addCommissonModel"
      :closable="false"
      :mask-closable="false"
      :title="modelTitle"
      width="50%"
    >
      <Row>
        <Form
          ref="addCommissonDataRef"
          :model="addCommissonData"
          :rules="ruleValidate"
          inline
          :label-width="100"
        >
          <!-- <Col span="12">
            <FormItem label="付款计划编号" prop="code">
              <Input
                disabled
                style="width: 100%"
                v-model="addCommissonData.code"
                placeholder="系统生成"
              />
            </FormItem>
          </Col> -->
          <Col span="12">
            <FormItem label="预付日期" prop="prepaidDate">
              <DatePicker
                :options="options"
                :value="addCommissonData.prepaidDate"
                :transfer="true"
                type="date"
                placeholder="请选择日期"
                @on-change="dateInvalidChange($event)"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="应付金额(元)" prop="payableAmount">
              <div>
                <InputNumber
                  v-model="addCommissonData.payableAmount"
                  :active-change="false"
                  :max="100000"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  placeholder="请输入应付金额"
                />
              </div>
            </FormItem>
          </Col>

          <Col span="9">
            <FormItem label="银行账户名称" prop="bank_id">
              <Select
                class="selectStyle"
                v-model="addCommissonData.bank_id"
                filterable
                :disabled="modelDisabled"
                transfer
                placeholder="请选择银行账户名称"
              >
                <!-- <Option value="912689974942367744">AAAAA</Option> -->
                <Option
                  :value="item.id"
                  :key="index"
                  v-for="(item, index) in accountInfoList"
                  >{{ item.bankAccountNamePro }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem>
              <p>支持精确到小数点后2位，输入最大值100000.00</p>
            </FormItem>
          </Col>
        </Form>
      </Row>

      <div slot="footer">
        <Button type="text" @click="addCommissonClose()">取消</Button>
        <Button type="primary" @click="addCommissonOk()">确定</Button>
      </div>
    </Modal>

    <Modal
      v-model="commissonDetailModel"
      :closable="false"
      title="付款记录"
      width="45%"
      :mask-closable="false"
    >
      <Row>
        <Form
          ref="commissonModelDetail"
          :model="commissonModelDetail"
          inline
          :label-width="110"
        >
          <Col span="12">
            <FormItem label="收款编号">
              <Input
                disabled
                style="width: 100%"
                v-model="commissonModelDetail.paymentNo"
                placeholder="系统生成"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="应付金额(元)">
              <div>
                <InputNumber
                  disabled
                  v-model="commissonModelDetail.actuallyPaidAmount"
                  :active-change="false"
                  :max="100000"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  placeholder="请输入应收金额（元）"
                />
                <p style="padding-left: 15%">
                  未付金额：{{ commissonModelDetail.unpaidAmount }} 元
                </p>
              </div>
            </FormItem>
          </Col>
          <Col
            span="24"
            style="border-bottom: dashed #666 1px；margin-bottom:15px"
          >
          </Col>
        </Form>
        <Col>
          <p style="font-size: 14px; margin: 15px 0">付款记录</p>
        </Col>

        <div v-for="(item, index) in commissonModelDetail.list" :key="index">
          <Form
            :ref="'item' + index"
            :rules="ruleValidateDetail"
            :model="item"
            inline
            :label-width="110"
          >
            <Row
              style="
                border-bottom: dashed #666 1px;
                padding-bottom: 15px;
                margin-top: 20px;
              "
            >
              <Col span="24">
                <FormItem label="实付金额(元)" prop="actuallyPaidAmount">
                  <InputNumber
                    v-model="item.actuallyPaidAmount"
                    @on-blur="actuallyPaidAmountChange()"
                    :active-change="false"
                    :max="100000"
                    :min="0"
                    :precision="2"
                    style="width: 100%"
                    placeholder="请输入应付金额"
                  />
                </FormItem>
                <span style="margin-left: 10%">
                  支持精确到小数点后2位，输入最大值100000.00
                </span>
              </Col>
              <Col span="12">
                <FormItem label="支付流水号">
                  <Input
                    style="width: 100%"
                    v-model="item.serialNumber"
                    placeholder="请输入支付流水号"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="付款日期" prop="paidDate">
                  <DatePicker
                    :options="options"
                    :value="item.paidDate"
                    :transfer="true"
                    type="date"
                    placeholder="请选择日期"
                    @on-change="dateInvalidDetailChange($event, index)"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="关联佣金结算单" prop="commissionStatementId">
                  <Select
                    v-model="item.commissionStatementId"
                    filterable
                    multiple
                    transfer
                    style="width: 100%"
                    placeholder="请选择关联发票"
                  >
                    <Option
                      :value="item.settlementNo"
                      :key="index"
                      v-for="(item, index) in settlementNoList"
                      >{{ item.settlementName }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col offset="20" span="4">
                <a style="color: #000" @click="delCommissonModelDetail(index)"
                  >删除记录<Icon size="25" color="red" type="ios-trash" /></a
              ></Col>
            </Row>
          </Form>
        </div>
        <p style="margin: 10px">
          <a @click="addCommissonModelDetail()">添加更多</a>
        </p>
      </Row>

      <div slot="footer">
        <Button type="text" @click="commissonClose()">取消</Button>
        <Button type="primary" @click="commissonOk()">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="invoiceUploadModel"
      :closable="false"
      title="发票上传"
      width="45%"
      :mask-closable="false"
    >
      <Row>
        <Form
          ref="invoiceUploadModel"
          :model="invoiceUploadModelList"
          inline
          :label-width="110"
        >
          <Col span="12">
            <FormItem label="付款计划编号">
              <Input
                disabled
                style="width: 100%"
                v-model="invoiceUploadModelList.paymentNo"
                placeholder="请输入付款计划编号"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="应付金额(元)">
              <div>
                <InputNumber
                  disabled
                  v-model="invoiceUploadModelList.actuallyPaidAmount"
                  :active-change="false"
                  :max="100000"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  placeholder="请输入应收金额（元）"
                />
                <p style="padding-left: 15%">
                  未付金额：{{ invoiceUploadModelList.unpaidAmount }} 元
                </p>
              </div>
            </FormItem>
          </Col>
          <Col
            span="24"
            style="border-bottom: dashed #666 1px；margin-bottom:15px"
          >
          </Col>
        </Form>
        <Col>
          <p style="font-size: 14px; margin: 15px 0">发票记录</p>
        </Col>

        <div v-for="(item, index) in invoiceUploadModelList.list" :key="index">
          <Form
            :ref="'items' + index"
            :rules="invoiceUploadRules"
            :model="item"
            inline
            :label-width="110"
          >
            <Row
              style="
                border-bottom: dashed #666 1px;
                padding-bottom: 15px;
                margin-top: 20px;
              "
            >
              <Col span="12">
                <FormItem label="发票编号" prop="billNo">
                  <Input
                    style="width: 100%"
                    v-model="item.billNo"
                    placeholder="请输入发票编号"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="发票金额(元)" prop="billAmount">
                  <InputNumber
                    v-model="item.billAmount"
                    :active-change="false"
                    @on-blur="billAmountChange()"
                    :max="100000"
                    :min="0"
                    :precision="2"
                    style="width: 100%"
                    placeholder="请输入发票金额"
                  />
                </FormItem>
              </Col>

              <Col span="24">
                <FormItem label="发票上传">
                  <div>
                    <Row>
                      <Col class="border" :span="item.url ? 4 : 0">
                        <img
                          v-if="item.url"
                          style="width: 100%"
                          :src="downloadUrl + '?imgPath=' + item.url"
                          alt=""
                        />
                        <a
                          v-if="item.url"
                          :href="downloadUrl + '?imgPath=' + item.url"
                          target="_blank"
                          >点击预览文件</a
                        >
                        <Icon
                          v-if="item.url"
                          class="trash"
                          type="ios-trash"
                          @click="delImage(url, index)"
                        />
                      </Col>
                      <Col span="4" :offset="item.url ? 1 : 0">
                        <Upload
                          :on-success="
                            (res, fileList) =>
                              handleSuccess(res, fileList, index)
                          "
                          :show-upload-list="false"
                          type="drag"
                          :format="['jpg', 'pdf', 'png']"
                          :on-format-error="handleFormatError"
                          :max-size="5120"
                          :on-exceeded-size="handleMaxSize"
                          :action="uploadUrl"
                        >
                          <div>
                            <div
                              v-if="item.url"
                              style="height: 62px; line-height: 62px"
                            >
                              重新上传
                            </div>
                            <Icon
                              v-else
                              type="md-add"
                              size="62"
                              style="color: #3399ff; margin-right: 10px"
                            />
                          </div>
                        </Upload>
                      </Col>
                      <Col span="12" offset="1"
                        >上传发票，支持jpg、png、pdf格式，限制5M以内</Col
                      >
                    </Row>
                  </div>
                </FormItem>
              </Col>
              <Col offset="20" span="4">
                <a style="color: #000" @click="delInvoiceUploadModelList(index)"
                  >删除记录<Icon size="25" color="red" type="ios-trash" /></a
              ></Col>
            </Row>
          </Form>
        </div>
        <p style="margin: 10px">
          <a @click="addInvoiceUploadModelList()">添加更多</a>
        </p>
      </Row>

      <div slot="footer">
        <Button type="text" @click="invoiceUploadClose()">取消</Button>
        <Button type="primary" @click="invoiceUploadOk()">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "EbizUiCollectionmanagementlist",

  data() {
    return {
      button: this.$store.state.app.button,
      total: 0,
      changeTableRowId: [],
      tableloading: false,
      addCommissonModel: false,
      commissonDetailModel: false,
      invoiceUploadModel: false,
      modelTitle: "",
      modelDisabled: false,
      downloadUrl: this.$api.downloadUrl,
      headers: { sid: window.sessionStorage.getItem("sid") },
      invoiceUploadModelList: {
        paymentNo: "",
        unpaidAmount: null,
        actuallyPaidAmount: null,
        list: [
          {
            billNo: "",
            billAmount: null,
            url: "",
          },
        ],
      },
      options: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        },
      },
      uploadUrl: this.$api.uploadImage,
      accountInfoList: [],
      settlementNoList: [],
      collectionManagement: {
        paymentNo: "",
        bankAccountName: "",
        billNo: "",
        date: [],
        paidDateStart: "",
        paidDateEnd: "",
        pageSize: 10,
        pageNum: 1,
      },
      addCommissonData: {
        // code: "",
        bank_id: "",
        // dzd: [],
        prepaidDate: "",
        payableAmount: null,
        paymentNo: "",
      },
      commissonModelDetail: {
        code: "",
        actuallyPaidAmount: null,
        unpaidAmount: null,
        list: [
          {
            id: "",
            actuallyPaidAmount: null,
            paidDate: "",
            commissionStatementId: [],
            serialNumber: null,
            url: "",
          },
        ],
      },
      collectionManagementTableList: [],
      collectionManagementColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "付款计划编号",
          key: "paymentNo",
          align: "center",
          width: 160,
        },
        {
          title: "银行账户名称",
          key: "bankAccountName",
          align: "center",
          width: 160,
        },
        {
          title: "银行账号",
          key: "bankAccount",
          align: "center",
          width: 160,
        },
        {
          title: "银行名称",
          key: "bankAccountName",
          align: "center",
          width: 160,
        },
        {
          title: "开户行名称",
          key: "branchBankName",
          align: "center",
          width: 160,
        },
        {
          title: "开户行地址",
          key: "branchBankAddress",
          align: "center",
          width: 160,
        },
        {
          title: "应付金额（元）",
          key: "payableAmount",
          align: "center",
          width: 100,
        },
        {
          title: "实付金额（元）",
          key: "actuallyPaidAmount",
          align: "center",
          width: 120,
        },
        {
          title: "未付金额（元）",
          key: "unpaidAmount",
          align: "center",
          width: 120,
        },
        {
          title: "付款状态",
          key: "paymentStatus",
          align: "center",
          width: 120,
          render: (h, p) => {
            if (p.row.paymentStatus == "0") {
              return h("div", "未支付");
            } else if (p.row.paymentStatus == "1") {
              return h("div", "部分支付");
            } else if (p.row.paymentStatus == "2") {
              return h("div", "已支付");
            }
          },
        },
        {
          title: "预付日期",
          key: "prepaidDate",
          align: "center",
          width: 140,
        },
        {
          title: "付款日期",
          key: "actualDate",
          align: "center",
          width: 140,
        },
        {
          title: "创建日期",
          key: "createdDate",
          align: "center",
          width: 140,
        },
        {
          title: "创建人",
          key: "createdUser",
          align: "center",
          width: 100,
        },
        {
          title: "更新日期",
          key: "modifiedDate",
          align: "center",
          width: 100,
        },
        {
          title: "更新人",
          key: "modifiedUser",
          align: "center",
          width: 100,
        },
        {
          title: "操作",
          width: 360,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    display: this.button.paymentManagement_edit
                      ? "inline-block"
                      : "none",
                  },
                  on: {
                    click: () => {
                      this.addManagement("ebiz", params.row);
                    },
                  },
                },
                "编辑计划"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    display: this.button.paymentManagement_list
                      ? "inline-block"
                      : "none",
                  },
                  on: {
                    click: () => {
                      this.seeCommissonModelDetail(params.row);
                    },
                  },
                },
                "付款记录"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    // disabled: params.row.agreementStatus == 3 ? true : false,
                  },
                  style: {
                    marginRight: "5px",
                    display: this.button.paymentManagement_upload
                      ? "inline-block"
                      : "none",
                  },
                  on: {
                    click: () => {
                      this.invoiceUpload(params.row);
                    },
                  },
                },
                "发票上传"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    // disabled: params.row.agreementStatus == 3 ? true : false,
                  },
                  style: {
                    marginRight: "5px",
                    display: this.button.paymentManagement_Export
                      ? "inline-block"
                      : "none",
                  },
                  on: {
                    click: () => {
                      this.reconciledExport(params.row);
                    },
                  },
                },
                "导出结算明细"
              ),
            ]);
          },
        },
      ],
      ruleValidate: {
        payableAmount: [
          {
            required: true,
            type: "number",
            message: "应付金额不能为空",
            trigger: "blur",
          },
        ],
        bank_id: [
          {
            required: true,
            message: "银行账户不能为空",
            trigger: "blur,change",
          },
        ],
        prepaidDate: [
          {
            required: true,
            message: "预付日期不能为空",
            trigger: "blur，change",
          },
        ],
      },
      ruleValidateDetail: {
        actuallyPaidAmount: [
          {
            type: "number",
            required: true,
            message: "金额不能为空",
            trigger: "blur",
          },
        ],
        paidDate: [
          {
            required: true,
            message: "收款日期不能为空",
            trigger: "blur,change",
          },
        ],
        commissionStatementId: [
          {
            type: "array",
            required: true,
            message: "请选择结算单",
            trigger: "blur,change",
          },
        ],
      },
      invoiceUploadRules: {
        billNo: [
          {
            required: true,
            message: "发票编号不能为空",
            trigger: "blur",
          },
        ],
        billAmount: [
          {
            required: true,
            type: "number",
            message: "发票金额不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.searchAccountInfoList(); //获取银行账户信息列表
    this.getSettlementNoList(); //付款管理用的获取佣金账单编号
  },
  mounted() {
    this.getPaymentQuery(1);
  },

  methods: {
    getPaymentQuery(page) {
      let data = { ...this.collectionManagement };
      if (page) {
        this.collectionManagement.pageNum = page;
      }
      this.$api.paymentQuery(data).then((res) => {
        if (res.respCode == 0) {
          this.total = res.content.total;
          this.collectionManagementTableList = res.content.list;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    searchAccountInfoList() {
      // searchAccountInfo
      this.$api.searchAccountInfo({ accountType: 0 }).then((res) => {
        if (res.respCode == 0) {
          this.accountInfoList = res.content;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    reset() {
      this.collectionManagement.paymentNo = "";
      this.collectionManagement.bankAccountName = "";
      this.collectionManagement.billNo = "";
      this.collectionManagement.paidDateStart = "";
      this.collectionManagement.paidDateEnd = "";
      this.collectionManagement.date = [];
      this.getPaymentQuery(1);
    },
    //换页
    changePage(page) {
      this.collectionManagement.pageNum = page;
      this.getPaymentQuery();
    },
    addManagement(type, row) {
      this.modelTitle = type == "add" ? "新增付款计划" : "编辑付款计划";
      this.modelDisabled = type == "add" ? false : true;
      this.addCommissonModel = true;
      if (type == "ebiz") {
        console.log(row, "row");
        this.addCommissonData.prepaidDate = row.prepaidDate;
        this.addCommissonData.bank_id = row.bankId;
        this.addCommissonData.payableAmount = row.payableAmount;
        this.addCommissonData.paymentNo = row.paymentNo;
      }
    },
    addCommissonOk() {
      this.$refs.addCommissonDataRef.validate((valid) => {
        if (valid) {
          let url =
            this.modelTitle == "新增付款计划" ? "paymentAdd" : "paymentEdit";
          let tip =
            this.modelTitle == "新增付款计划" ? "新增成功!" : "编辑成功!";
          let data = {
            paymentNo: this.addCommissonData.paymentNo,
            prepaidDate: this.addCommissonData.prepaidDate,
            payableAmount: this.addCommissonData.payableAmount,
          };
          this.$api[url](
            this.modelTitle == "新增付款计划" ? this.addCommissonData : data
          ).then((res) => {
            if (res.result == 0) {
              this.$Message.success(tip);
              this.getPaymentQuery();
              this.addCommissonModel = false;
              this.addCommissonData.bank_id = "";
              this.addCommissonData.prepaidDate = "";
              this.addCommissonData.payableAmount = null;
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    addCommissonClose() {
      this.$refs.addCommissonDataRef.resetFields();
      this.addCommissonModel = false;
    },
    seeCommissonModelDetail(row) {
      let data = {
        paymentNo: row.paymentNo,
      };
      this.$api.recordPaymentQuery(data).then((res) => {
        if (res.respCode == 0) {
          this.commissonDetailModel = true;
          this.commissonModelDetail.list = res.content;
          this.commissonModelDetail.paymentNo = row.paymentNo;
          this.commissonModelDetail.actuallyPaidAmount = row.payableAmount;
          let num = 0;
          res.content.map((item) => {
            num += item.actuallyPaidAmount;
          });
          this.commissonModelDetail.unpaidAmount = row.payableAmount - num;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    dateInvalidChange(date) {
      this.addCommissonData.prepaidDate = date;
    },
    dateInvalidDetailChange(date, index) {
      this.commissonModelDetail.list[index].paidDate = date;
    },
    handleMaxSize(file) {
      this.$Message.error("上传的文件大小最大为1M");
    },
    handleFormatError(file) {
      this.$Message.error("上传的文件格式不正确");
    },
    handleSuccess(res, file, index) {
      if (res.content.result == 0) {
        this.invoiceUploadModelList.list[index].url = res.content.path;
        this.$Message.success("上传成功");
      } else {
        this.$Message.error(res.message);
      }
    },
    addCommissonModelDetail() {
      this.commissonModelDetail.list.push({
        actuallyPaidAmount: null,
        paidDate: "",
        commissionStatementId: [],
        serialNumber: "",
        url: "",
      });
    },
    addInvoiceUploadModelList() {
      this.invoiceUploadModelList.list.push({
        billAmount: null,
        billNo: null,
        url: "",
      });
    },
    delCommissonModelDetail(index) {
      this.commissonModelDetail.list.splice(index, 1);
      let num = 0;
      this.commissonModelDetail.list.map((item) => {
        num += item.actuallyPaidAmount;
      });
      this.commissonModelDetail.unpaidAmount =
        this.commissonModelDetail.actuallyPaidAmount - num;
      this.$Message.success("删除成功");
    },
    delInvoiceUploadModelList(index) {
      this.invoiceUploadModelList.list.splice(index, 1);
      let unpaidAmount = null;
      this.invoiceUploadModelList.list.map((item) => {
        unpaidAmount += item.billAmount;
      });
      this.invoiceUploadModelList.unpaidAmount =
        this.invoiceUploadModelList.actuallyPaidAmount - unpaidAmount;
      this.$Message.success("删除成功");
    },
    commissonClose() {
      this.commissonDetailModel = false;
      // this.$refs.formInline.resetFields();
    },
    invoiceUploadClose() {
      this.invoiceUploadModel = false;
      // this.$refs.formInline.resetFields();
    },
    commissonOk() {
      let This = this;
      let allValidate = [];
      this.commissonModelDetail.list.forEach((item, index) => {
        //有多个输入框需校验，待都校验成功后再进行别的操作，所以需要使用Promise
        allValidate.push(
          new Promise((rev, rej) => {
            //划重点：This.$refs['item'+index][0]
            This.$refs["item" + index][0].validate((valid) => {
              if (valid) {
                rev();
              } else {
                rej();
              }
            });
          })
        );
      });
      Promise.all(allValidate)
        .then(() => {
          //所有输入框都校验成功后的处理
          let data = this.commissonModelDetail.list.map((item) => {
            this.$set(item, "paymentNo", this.commissonModelDetail.paymentNo);
            // this.$set(item, "id", this.commissonModelDetail.paymentNo);
          });
          let obj = {
            paymentNo: this.commissonModelDetail.paymentNo,
            ebizPaymentRecordDTO: this.commissonModelDetail.list,
          };
          this.$api.recordPayment(obj).then((res) => {
            if (res.result == 0) {
              this.$Message.success("修改记录成功");
              this.commissonDetailModel = false;
              this.getPaymentQuery(1);
            } else {
              this.$Message.error(
                res.content ? res.content : res.resultMessage
              );
            }
          });
        })
        .catch(() => {});
    },
    invoiceUploadOk() {
      let This = this;
      let allValidate = [];
      this.invoiceUploadModelList.list.forEach((item, index) => {
        // console.log(item, "item");
        //有多个输入框需校验，待都校验成功后再进行别的操作，所以需要使用Promise
        allValidate.push(
          new Promise((rev, rej) => {
            //划重点：This.$refs['item'+index][0]
            This.$refs["items" + index][0].validate((valid) => {
              if (valid) {
                // console.log(this.invoiceUploadModelList, "666");
                rev();
              } else {
                // console.log("555");
                rej();
              }
            });
          })
        );
      });
      Promise.all(allValidate)
        .then(() => {
          //所有输入框都校验成功后的处理
          this.invoiceUploadModelList.list.map((item) => {
            this.$set(item, "paymentNo", this.invoiceUploadModelList.paymentNo);
            item.billAmount = item.billAmount + "";
            // this.$set(item, "id", this.commissonModelDetail.paymentNo);
          });
          let data = {
            paymentNo: this.invoiceUploadModelList.paymentNo,
            ebizUploadInvoiceDTOList: this.invoiceUploadModelList.list,
          };
          this.$api.uploadInvoice(data).then((res) => {
            if (res.result == 0) {
              this.$Message.success("操作成功");
              this.invoiceUploadModel = false;
            } else {
              this.$Message.error(
                res.content ? res.content : res.resultMessage
              );
            }
          });
        })
        .catch(() => {});
    },
    invoiceUpload(row) {
      let data = {
        paymentNo: row.paymentNo,
      };
      this.$api.billPaymentQuery(data).then((res) => {
        if (res.respCode == 0) {
          this.invoiceUploadModel = true;
          this.invoiceUploadModelList.list = res.content;
          this.invoiceUploadModelList.paymentNo = row.paymentNo;
          this.invoiceUploadModelList.actuallyPaidAmount = row.payableAmount;
          let num = 0;
          res.content.map((item) => {
            num += item.billAmount;
          });
          this.invoiceUploadModelList.unpaidAmount =
            parseFloat(row.payableAmount) - num;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    paymentTemplate() {
      this.exportFile({
        url: this.$api.paymentTemplate,
        name: "付款导入模板",
        fileType: "xlsx",
      });
    },
    //上传中
    handleProgress(res) {
      // this.pdfloading =true;
    },
    handleSuccessRecord(res, file) {
      console.log(res);
      if (res.content.result && res.content.result == 0) {
        this.$Message.success("导入成功");
        this.getPaymentQuery(1);
      } else {
        this.$Message.error({
          content: res.content.content,
          duration: 5,
        });
      }
    },
    tableSelect(row) {
      this.changeTableRowId = row.map((item) => {
        return { paymentNo: item.paymentNo };
      });
      console.log(this.changeTableRowId, "this.changeTableRowId");
    },
    paymentExport() {
      this.$api.paymentExportList(this.changeTableRowId).then((res) => {
        let elink = document.createElement("a");
        elink.download = "付款记录.xlsx";
        elink.style.display = "none";
        let blob = new Blob([res]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        this.changeTableRowId = [];
      });
    },
    paymentDel() {
      if (this.changeTableRowId.length == 0) {
        this.$Message.error("请选择要删除的数据");
      } else {
        this.$Modal.confirm({
          title: "确认删除提示",
          content: "<p>是否确认删除</p>",
          onOk: () => {
            this.$api.paymentDeleteBatch(this.changeTableRowId).then((res) => {
              if (res.result == 0) {
                this.$Message.success("删除成功");
                this.changeTableRowId = [];
                this.getPaymentQuery(1);
              } else {
                this.$Message.error(res.resultMessage);
              }
            });
          },
        });
      }
    },
    actuallyPaidAmountChange() {
      let unpaidAmount = null;
      this.commissonModelDetail.list.map((item) => {
        unpaidAmount += item.actuallyPaidAmount;
      });
      this.commissonModelDetail.unpaidAmount =
        this.commissonModelDetail.actuallyPaidAmount - unpaidAmount;
    },
    billAmountChange() {
      let unpaidAmount = null;
      this.invoiceUploadModelList.list.map((item) => {
        unpaidAmount += item.billAmount;
      });
      this.invoiceUploadModelList.unpaidAmount =
        this.invoiceUploadModelList.actuallyPaidAmount - unpaidAmount;
    },
    getSettlementNoList() {
      this.$api.getSettlementNoList().then((res) => {
        if (res.result == 0) {
          this.settlementNoList = res.content;
        } else {
          this.$Message.error(res.resultMessage);
        }
      });
    },
    reconciledExport(row) {
      this.$api.settlementExcel(row.commissionStatementId).then((res) => {
        let elink = document.createElement("a");
        elink.download = row.paymentNo + "--结算明细.xlsx";
        elink.style.display = "none";
        let blob = new Blob([res]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        this.changeTableRowId = [];
      });
      // this.exportFile({
      //   url:
      //     this.$api.settlementExcel +
      //     "?receivePaymentId=" +
      //     row.receivePaymentId,
      //   name: row.paymentNo + "--结算明细",
      //   fileType: "xlsx",
      // });
    },
    delImage(url, index) {
      this.invoiceUploadModelList.list[index].url = "";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  width: 470px;
}
/deep/
  .selectStyle.ivu-select-default.ivu-select-multiple
  .ivu-select-selection {
  width: 100%;
}
/deep/
  .v-transfer-dom
  .ivu-modal-wrap
  .ivu-modal
  .ivu-modal-content
  .ivu-modal-header
  .ivu-modal-header-inner {
  font-size: 20px !important;
  font-weight: 500 !important;
}
/deep/ .ivu-modal-content {
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 6px;
  max-height: 500px;
  overflow-y: auto;
  background-clip: padding-box;
  -webkit-box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
}
/deep/ .ivu-upload-drag {
  width: 62px;
}
/deep/ .ivu-modal {
  top: 0;
}
</style>